import React from 'react';
import { IProps } from './types';
import { STEP } from '../types';

const ProcessBar: React.FC<IProps> = (props) => {
  const { activeStep } = props;

  return (
    <div className="process-bar">
      <div className={`process-bar__item process-bar__item${activeStep === STEP.calcBill ? ' process-bar__item--active' : ''}`}>
        <div className="process-bar__item-icon process-bar__item-icon--calc" />
        <span>我要試算</span>
      </div>
      <div className={`process-bar__item process-bar__item${activeStep === STEP.infoFill ? ' process-bar__item--active' : ''}`}>
        <div className="process-bar__item-icon process-bar__item-icon--fill" />
        <span>填寫資料</span>
      </div>
      <div className={`process-bar__item process-bar__item${activeStep === STEP.infoCheck ? ' process-bar__item--active' : ''}`}>
        <div className="process-bar__item-icon process-bar__item-icon--fill" />
        <span>告知事項</span>
      </div>
      <div className={`process-bar__item process-bar__item${activeStep === STEP.preview ? ' process-bar__item--active' : ''}`}>
        <div className="process-bar__item-icon process-bar__item-icon--preview" />
        <span>資料預覽</span>
      </div>
      <div className={`process-bar__item process-bar__item${activeStep === STEP.payment ? ' process-bar__item--active' : ''}`}>
        <div className="process-bar__item-icon process-bar__item-icon--pay" />
        <span>確認付款</span>
      </div>
      <div className={`process-bar__item process-bar__item${activeStep === STEP.success ? ' process-bar__item--active' : ''}`}>
        <div className="process-bar__item-icon process-bar__item-icon--success" />
        <span>成功投保</span>
      </div>
    </div>
  );
};

export default ProcessBar;
